var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalytics = function SvgAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M29.334 29.333H16c-6.285 0-9.428 0-11.38-1.952C2.667 25.428 2.667 22.285 2.667 16V2.667"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m25.334 9.334-4.158 5.235c-.637.802-.955 1.203-1.32 1.398a2 2 0 0 1-1.809.04c-.373-.18-.709-.567-1.38-1.34s-1.007-1.16-1.38-1.34a2 2 0 0 0-1.809.04c-.365.195-.684.596-1.32 1.398L8 20"
  })));
};
export default SvgAnalytics;